import {
  AnimatedButtonContainer,
  AnimatedButtonRow,
  Button,
} from "@babackapp/customer-ui/components/button";
import {
  Header,
  HeaderDescription,
  HeaderTitle,
  SectionHeader,
} from "@babackapp/customer-ui/components/header";
import { WidgetPage } from "@babackapp/customer-ui/components/widget-page";
import {
  Article,
  ArticleImage,
  ArticleList,
  ArticleSubtitle,
  ArticleTitle,
} from "@babackapp/customer-ui/components/article";
import { formatPrice } from "@babackapp/return-widget-components/utils/format-price";
import { EnterIcon } from "@radix-ui/react-icons";
import { ShoppingBagIcon } from "lucide-react";
import { Suspense } from "react";
import { useShopNowResolve } from "../hooks/use-shop-now-resolve";
import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";

function ShopNowResolveInner() {
  const { items, currency, cartTotal, handleAddMore, handleConfirm } = useShopNowResolve();
  const t = useCustomText();

  return (
    <WidgetPage>
      <Header>
        <HeaderTitle>{t("shopNowResolve.title")}</HeaderTitle>
        <HeaderDescription>
          {t("shopNowResolve.description")}
        </HeaderDescription>
      </Header>
        <div className="w-full flex flex-col gap-4">
          <SectionHeader>{t("shopNowResolve.sectionTitle")}</SectionHeader>
          <ArticleList>
            {items.map((item, i) => (
              <Article key={`${item.variantId}-${i}`}>
                {item.image && (
                  <ArticleImage src={item.image} layoutId={`img-shop-now-${item.variantId}`} />
                )}
                <ArticleTitle>{item.title}</ArticleTitle>
                <ArticleSubtitle>
                  ×{item.quantity} · {formatPrice(item.price * item.quantity, currency)}
                </ArticleSubtitle>
              </Article>
            ))}
          </ArticleList>
          <div className="flex justify-between text-sm font-medium px-1">
            <span>{t("shopNowResolve.cartTotal")}</span>
            <span>{formatPrice(cartTotal, currency)}</span>
          </div>
        </div>

      <AnimatedButtonRow variants={{}}>
        <AnimatedButtonContainer layoutId="shop-now-add-more" variants={{}}>
          <Button variant="secondary" onClick={handleAddMore}>
            <ShoppingBagIcon />
            {t("shopNowResolve.addMore")}
          </Button>
        </AnimatedButtonContainer>
        <AnimatedButtonContainer layoutId="shop-now-resolve-confirm" variants={{}}>
          <Button disabled={items.length === 0} onClick={handleConfirm}>
            <EnterIcon />
            {t("shopNowResolve.confirm")}
          </Button>
        </AnimatedButtonContainer>
      </AnimatedButtonRow>
    </WidgetPage>
  );
}

export function ShopNowResolvePage() {
  return (
    <Suspense fallback={null}>
      <ShopNowResolveInner />
    </Suspense>
  );
}
